import { isDesignToken as r } from "@aws-amplify/ui";
import { getCSSVariableIfValueIsThemeKey as t } from "../utils.js";
const o = _ref => {
  let {
    breakpoint: o,
    breakpoints: e,
    propKey: i,
    values: n
  } = _ref;
  if (r(n)) return n.toString();
  if ("object" != typeof n) return t(i, n);
  let s = {};
  const p = Object.keys(e).sort((r, t) => e[r] - e[t]);
  return Array.isArray(n) ? n.map((r, t) => {
    s[p[t]] = r;
  }) : s = n, (_ref2 => {
    let {
      breakpoint: o,
      breakpoints: e,
      propKey: i,
      values: n
    } = _ref2;
    if (void 0 !== n[o]) {
      const e = n[o];
      return r(e) ? e.toString() : t(i, e);
    }
    const s = Object.keys(e).sort((r, t) => e[t] - e[r]),
      p = s.slice(s.indexOf(o));
    for (const o of p) if (void 0 !== n[o]) {
      const e = n[o];
      return r(e) ? e.toString() : t(i, e);
    }
    return null;
  })({
    breakpoint: o,
    breakpoints: e,
    propKey: i,
    values: s
  });
};
export { o as getValueAtCurrentBreakpoint };